"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadHistoryColumnProps = exports.DeletedListColumnProps = void 0;
const constants_1 = require("utils/constants");
const custom_filter_1 = require("components/atoms/custom-filter");
const AdjustmentStockpileColumnProps = [
    {
        show: true,
        locked: true,
        field: 'is_duplicated',
        title: 'Is Duplicated',
        width: '125',
        filter: 'boolean'
    },
    {
        show: true,
        locked: true,
        field: 'ticket_no',
        title: 'Ticket No',
        width: '150',
        filter: 'text'
    },
    {
        show: true,
        field: 'pos_name',
        title: 'Pos',
        width: '125',
        filter: 'text',
    },
    {
        show: true,
        field: 'main_entrance_in',
        title: 'Enterance In',
        width: '200',
        filter: 'date',
        format: constants_1.formatGridDate.ddMMyyyyHHmm
    },
    {
        show: true,
        width: '200',
        field: 'gate_in',
        title: 'Gate In',
        filter: 'date',
        format: constants_1.formatGridDate.ddMMyyyyHHmm
    },
    {
        show: true,
        width: '150',
        field: 'queue_time',
        title: 'Queue Time',
        filterCell: custom_filter_1.FilterTImePicker,
    },
    {
        show: true,
        width: '200',
        field: 'gate_out',
        title: 'Exit Gate',
        filter: 'date',
        format: constants_1.formatGridDate.ddMMyyyyHHmm
    },
    {
        show: true,
        width: '150',
        field: 'lead_time',
        title: 'Lead Time',
        filterCell: custom_filter_1.FilterTImePicker,
    },
    {
        show: true,
        field: 'contractor_dt_code',
        title: 'Contractor DT',
        width: '125',
        filter: 'text',
    },
    {
        show: true,
        field: 'dumptruck_no',
        title: 'DT NO',
        width: '100',
        filter: 'text',
    },
    {
        show: true,
        field: 'capacity_volume',
        title: 'Capacity',
        width: '150px',
        filter: 'numeric'
    },
    {
        show: true,
        field: 'penalty',
        title: 'Penalty',
        width: '100',
        filter: 'text',
    },
    {
        show: true,
        field: 'nett_volume',
        title: 'Nett Volume',
        width: '150px',
        filter: 'numeric'
    },
    {
        show: true,
        field: 'contractor_ex_code',
        title: 'Contractor Excavator',
        width: '125',
        filter: 'text',
    },
    {
        show: true,
        field: 'excavator_no',
        title: 'Excavator',
        width: '100',
        filter: 'text',
    },
    {
        show: true,
        field: 'pit_name',
        title: 'Pit',
        width: '100',
        filter: 'text',
    },
    {
        show: true,
        field: 'area_name',
        title: 'Area',
        width: '100',
        filter: 'text',
    },
    {
        show: true,
        field: 'seam_name',
        title: 'Seam',
        width: '100',
        filter: 'text',
    },
    {
        show: true,
        field: 'brand_name',
        title: 'Brand',
        width: '100',
        filter: 'text',
    },
    {
        show: true,
        field: 'filename_penalty_evidence',
        title: 'Image Penalty',
        width: '180',
        sortable: false,
        filterable: false,
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180',
        filter: 'text'
    }
];
const DeletedListColumnProps = [
    {
        show: true,
        field: 'ticket_no',
        title: 'Ticket No',
        width: '180px',
        filter: 'text'
    },
    {
        show: true,
        field: 'main_entrance_in',
        title: 'Date',
        width: '155px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMyyyyHHmm}`
    },
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        width: '150px',
        filter: 'text'
    },
    {
        show: true,
        field: 'dumptruck_no',
        title: 'DT NO',
        width: '100px',
        filter: 'text'
    },
    {
        show: true,
        field: 'nett_volume',
        title: 'Net Capacity',
        width: '150px',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Deleted By',
        width: '150px',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Deleted Date',
        width: '150px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY}`
    },
    {
        show: true,
        field: 'reason',
        title: 'Reason',
        width: '200px',
        filter: 'text'
    }
];
exports.DeletedListColumnProps = DeletedListColumnProps;
const UploadHistoryColumnProps = [
    {
        show: true,
        field: 'action',
        title: 'Action',
        width: '75',
        sortable: false,
        filterable: false,
    },
    {
        show: true,
        field: 'filename',
        title: 'File Name',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'type',
        title: 'Type',
        width: '150',
        filter: 'text',
    },
    {
        show: true,
        field: 'status',
        title: 'Status',
        width: '110',
        filter: 'text',
    },
    {
        show: true,
        field: 'log_message',
        title: 'Log',
        width: '110',
        sortable: false,
        filterable: false,
    },
    {
        show: true,
        field: 'uploaded_at',
        title: 'Export At',
        width: '175px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'uploaded_by',
        title: 'Uploaded by',
        width: '175px',
        filter: 'text'
    },
];
exports.UploadHistoryColumnProps = UploadHistoryColumnProps;
exports.default = AdjustmentStockpileColumnProps;
